import type { ReservationId } from "@@/shared/acquire/reservations/reservation-id";
import type { ResourceId } from "@@/shared/acquire/resources/resource-id";
import type {
    IsoAndUnixTimestamp} from "@@/shared/date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
} from "@@/shared/date-time/iso-and-unix";
import type { OrderId } from "@@/shared/orders/order-id";
import type { ProviderId } from "@@/shared/providers/provider-id";
import type {
    StatusEventId} from "@@/shared/statuses/status-event-id";
import {
    statusEventIdZodSchema,
} from "@@/shared/statuses/status-event-id";
import { statusReferencesZodObject } from "@@/shared/statuses/status-references";
import { customerIdZodSchema } from "@@/shared/users/customer-id";
import type { SystemUser} from "@@/shared/users/system-user";
import { systemUserZodSchema } from "@@/shared/users/system-user";
import type { UserId} from "@@/shared/users/user-id";
import { userIdZodSchema } from "@@/shared/users/user-id";
import type { ZodLiteral} from "zod";
import { z } from "zod";

type _StatusEventBase = {
    _id: StatusEventId;
    _type: "STATUS_EVENT";
    _createdAt: IsoAndUnixTimestamp;
    _createdBy: UserId | SystemUser;
    type: Uppercase<string>;
    references: {
        resourceId?: ResourceId;
        reservationId?: ReservationId;
        orderId?: OrderId;
        userId?: UserId;
        providerId?: ProviderId;
    };
};

const statusEventZodObjectFactory = <
    StatusTypeZodLiteral extends ZodLiteral<string>,
>(
    statusTypeZodString: StatusTypeZodLiteral,
) => {
    const statusEventBaseZodObject = z.object({
        _id: statusEventIdZodSchema,
        _type: z.literal("STATUS_EVENT"),
        _createdAt: isoAndUnixZodSchema,
        _createdBy: z.union([
            userIdZodSchema,
            customerIdZodSchema,
            systemUserZodSchema,
        ]),
        type: statusTypeZodString,
        references: statusReferencesZodObject,
    });
    const statusEventBaseFactoryParamsZodObject = z.object({
        _createdBy: z.union([
            userIdZodSchema,
            customerIdZodSchema,
            systemUserZodSchema,
        ]),
        references: statusReferencesZodObject,
    });
    return {
        statusEventBaseZodObject,
        statusEventBaseFactoryParamsZodObject,
    };
};

export { statusEventZodObjectFactory };
